import Vue from 'vue'
import Vuex from 'vuex'
import pageStore  from '@/store/page.store'; 
import teacherGuideStore  from '@/store/teacher-guide.store'; 
import i18nStore from '@/store/i18n.store';

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    page: pageStore,
    teacherGuide: teacherGuideStore,
    i18n: i18nStore
  }
}) 